import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, CanActivate, ActivatedRouteSnapshot, 
         RouterStateSnapshot, Route, CanLoad } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

    constructor(private router: Router,
                private location: Location) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let caminho = this.location.path();
        let index = 0;
        for (let i = caminho.length; i > 0; i--) {
            if (caminho[i] == '/'){
                index = i;
            }
        }
        
        let url: string = state.url;
        let cnpj = `${caminho.substring(0, index)}`;

        return this.checkLogin(url, cnpj);
    }

    canLoad(route: Route): boolean {
        let caminho = this.location.path();
        let index = 0;
        for (let i = caminho.length; i > 0; i--) {
            if (caminho[i] == '/'){
                index = i;
            }
        }
        let url = `/${route.path}`;
        let cnpj = `${caminho.substring(0, index)}`;
        localStorage.setItem('currentURL', caminho);

        return this.checkLogin(url, cnpj);
    }

    checkLogin(url: string, cnpj: string): boolean {
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }
        this.router.navigate([cnpj,'login']);
        return false;

    }
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts